import Enumerable from "linq";
import store from "../../../../store";
import { ExecuteRequest, ExternalScriptExecuteResult, ScriptLinkItem } from "../../../../domain/localhost/items";
import { IInternalScriptProcessible } from "../IInternalScriptProcessible";

class ReplaceInformation {
  targetObjectName: string;
  newValue: string;
}

export class GeneralReplacer implements IInternalScriptProcessible {
  public isProcessible(request: ExecuteRequest): boolean {
    const configuration = store.state.configuration.behavior.localhost.internalScript.scripts.generalReplacer;
    return configuration.isEnable
        && (new RegExp(configuration.pathExpression, "i")).test(request.exePath)
        && this.isSimpleReplaceMode(request);
  }

  private isSimpleReplaceMode(request: ExecuteRequest): boolean {
    try {
      if (Enumerable.from(request.arguments).any(a => a.toLowerCase() === "-action")) {
        // actionの指定があるときはSELECT発行するので内部実装では対応できない
        return false;
      }
      // constが複数ある時は空文字の対応がV1で不定となるように見えるので、内部実装では対応しない
      return Enumerable.from(request.arguments).where(a => a.toLowerCase() === "-const").count() === 1;
    } catch (e) {
      // Errorは発生させないようにしているが念のためcatchしている
      console.error(e);
      return false;
    }
  }

  public async process(request: ExecuteRequest): Promise<ExternalScriptExecuteResult> {
    const info = this.getReplaceInformation(request.arguments);
    return this.toResult(request, info);
  }

  private getReplaceInformation(argumentTexts: string[]): ReplaceInformation {
    for (let i = 0; i < argumentTexts.length; ++i) {
      if (argumentTexts[i].toLowerCase() !== "-const") { continue; }
      const info = new ReplaceInformation();
      info.targetObjectName = (i + 1 < argumentTexts.length) ? argumentTexts[i + 1] : null;
      info.newValue = (i + 2 < argumentTexts.length) ? argumentTexts[i + 2] : null;
      return info;
    }
    return new ReplaceInformation();
  }

  private toResult(request: ExecuteRequest, info: ReplaceInformation): ExternalScriptExecuteResult {
    const result = new ExternalScriptExecuteResult();
    result.isComplete = true;
    result.name = undefined;
    result.values = [];
    result.compressedCsvText = "";
    // V1は空文字をダブルクォーテーションで囲っていないのでGeneralReplacer.exeに意図したとおりに渡っていなくて更新できていない
    // おそらく意図した挙動ではなくV1の不具合と思われるので、空でも更新できるようにしている
    // ただし、引数が足りていないときは更新しないようにしている
    result.scriptLinkResults = Enumerable.from(request.scriptLinkItems)
      .where(i => !!info.targetObjectName && (info.newValue != null) && info.targetObjectName === i.name)
      .select(i => this.toClonedItem(i, info.newValue))
      .toArray();
    return result;
  }

  private toClonedItem(item: ScriptLinkItem, newValue: string): any {
    const cloned = item.clone();
    cloned.value = newValue;
    return cloned;
  }
}
